import { useTranslation } from 'react-i18next';
import { humanizeEnum } from '@/lib/utils';
import { Money, Row, day } from './bodyParts';

export interface ExpenseDetail {
  id: string;
  description: string;
  reference?: string | null;
  amount: number | string;
  status: string;
  expenseDate: string;
  paymentMethod: string;
  notes?: string | null;
  rejectionReason?: string | null;
  category?: { name: string } | null;
  bankAccount?: { name: string } | null;
}

/** Read-only expense for the record viewer (POS-I239). */
export function ExpenseDetailBody({ data }: { data: ExpenseDetail }) {
  const { t } = useTranslation('records');
  return (
    <div className="space-y-5 text-sm">
      <dl className="space-y-1.5">
        <Row label={t('rvDate')}><span dir="ltr">{day(data.expenseDate)}</span></Row>
        <Row label={t('rvDescription')}>{data.description}</Row>
        {data.category?.name && <Row label={t('rvCategory')}>{data.category.name}</Row>}
        <Row label={t('rvAmount')}><Money value={data.amount} /></Row>
        <Row label={t('rvMethod')}>{humanizeEnum(data.paymentMethod)}</Row>
        {data.bankAccount?.name && <Row label={t('rvBankAccount')}>{data.bankAccount.name}</Row>}
        {data.reference && <Row label={t('rvReference')}><bdi dir="ltr">{data.reference}</bdi></Row>}
        {data.rejectionReason && <Row label={t('rvRejectionReason')}>{data.rejectionReason}</Row>}
        {data.notes && <Row label={t('rvNotes')}>{data.notes}</Row>}
      </dl>
    </div>
  );
}
